import Navbar from "./components/Navbar";
import Home from "./components/Home";
import Carousel from "./components/Carousel";
import Skills from "./components/Skills"
import Experience from "./components/Experience"
import Modal from "./components/Modal"

function App() {

  let slides = [
    <Home />,
    <Experience />,
    <Skills />,
  ];

  let slides_2 = [
    <Experience />,
    <Skills />,
  ];

  return (
    <div>

      {/* <Modal /> */}
      
      <div className="relative z-20">
        <Navbar />
      </div>

      <div className="hidden lg:flex">
        <Home />
      </div>

      <div className="lg:hidden">
        <Carousel slides={slides} />
      </div>

      <div className="hidden lg:flex">
        <Carousel slides={slides_2} />
      </div>
      
    </div>
  );
}

export default App;